var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var EncryptionHandler = /** @class */ (function () {
    function EncryptionHandler(iv, params) {
        this._iv = iv;
        this._params = params;
    }
    EncryptionHandler.getEncryptor = function () {
        var iv = crypto.getRandomValues(new Uint8Array(16));
        var params = {
            name: 'AES-CBC',
            iv: iv
        };
        return new EncryptionHandler(iv, params);
    };
    EncryptionHandler.getDecryptor = function (iv) {
        var params = {
            name: 'AES-CBC',
            iv: iv
        };
        return new EncryptionHandler(iv, params);
    };
    Object.defineProperty(EncryptionHandler.prototype, "params", {
        get: function () {
            return this.params;
        },
        enumerable: true,
        configurable: true
    });
    EncryptionHandler.prototype.setIV = function (iv) {
        this._iv = iv;
        this._params = {
            name: 'AES-CBC',
            iv: iv
        };
    };
    EncryptionHandler.prototype.resetIV = function () {
        var iv = crypto.getRandomValues(new Uint8Array(16));
        this._iv = iv;
        this._params = {
            name: 'AES-CBC',
            iv: iv
        };
    };
    EncryptionHandler.prototype.setKey = function (keyString) {
        return __awaiter(this, void 0, void 0, function () {
            var key;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, crypto.subtle.importKey('raw', this.stringToByteArray(keyString), 'AES-CBC', false, ['encrypt', 'decrypt'])];
                    case 1:
                        key = _a.sent();
                        this._key = key;
                        return [2 /*return*/];
                }
            });
        });
    };
    EncryptionHandler.prototype.encryptBlob = function (blob) {
        return __awaiter(this, void 0, void 0, function () {
            var blobBuffer, blobEncrypted, tmp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, new Response(blob).arrayBuffer()];
                    case 1:
                        blobBuffer = _a.sent();
                        return [4 /*yield*/, crypto.subtle.encrypt(this._params, this._key, blobBuffer)];
                    case 2:
                        blobEncrypted = _a.sent();
                        tmp = new Uint8Array(this._iv.byteLength + blobEncrypted.byteLength);
                        tmp.set(this._iv, 0);
                        tmp.set(new Uint8Array(blobEncrypted), this._iv.byteLength);
                        return [2 /*return*/, tmp.buffer];
                }
            });
        });
    };
    EncryptionHandler.prototype.decryptBlob = function (blob) {
        return __awaiter(this, void 0, void 0, function () {
            var blobBuffer, blobDecrypted;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, new Response(blob).arrayBuffer()];
                    case 1:
                        blobBuffer = _a.sent();
                        return [4 /*yield*/, crypto.subtle.decrypt(this._params, this._key, blobBuffer)];
                    case 2:
                        blobDecrypted = _a.sent();
                        return [2 /*return*/, blobDecrypted];
                }
            });
        });
    };
    EncryptionHandler.prototype.stringToByteArray = function (value) {
        var enc = new TextEncoder();
        return enc.encode(value); // default uft-8
    };
    return EncryptionHandler;
}());
export { EncryptionHandler };
